import { SURVEY_EDITOR_COPY_TO_ANSWERING_PAGE } from "../../../constants";

export const copyEditSurveyGoalsToAnsweringPage = (payload) => {
    return (dispatch, getState) => {
        const wizardReducer = getState().NewSurveyWizardReducer
        dispatch({ type: SURVEY_EDITOR_COPY_TO_ANSWERING_PAGE, payload: { wizardReducer, ...payload } });
    }
}